import React from 'react';
import { Loader, LoaderProps } from 'semantic-ui-react';

export type IATMLoaderProps = LoaderProps;

export const ATMLoader: React.FC<LoaderProps> = ({ children, ...props }) => (
  <Loader {...props}>{children}</Loader>
);
